import Navbar from "@/components/site/Navbar";
import Whitelist from "@/components/site/Whitelist";
import Footer from "@/components/site/Footer";

export default function ApplyPage() {
  return (
    <div className="App min-h-screen">
      <Navbar />
      <main className="pt-[72px]">
        <Whitelist />
      </main>
      <Footer />
    </div>
  );
}
